import { ReactComponent as Home } from '@assets/icons/home.svg';
import { ReactComponent as List } from '@assets/icons/list.svg';
import { ReactComponent as SignIn } from '@assets/icons/sign_in.svg';
import { ReactComponent as SignOut } from '@assets/icons/sign_out.svg';
import { KeyPressDetails, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { FC, useMemo } from 'react';

import * as styles from './styles';

export type IconType = 'home' | 'list' | 'sign_in' | 'sign_out';

interface FocusableNavItemProps {
  name: IconType;
  isWide: boolean;
  onEnterPress: (props: object, details: KeyPressDetails) => void;
}

// TODO: fix to get focus when `isWide` is `false`
const FocusableNavItem: FC<FocusableNavItemProps> = (props) => {
  const { name, isWide, onEnterPress } = props;
  const { ref, focused } = useFocusable({ onEnterPress });
  const [Icon, text] = useMemo(() => {
    switch (name) {
      default:
      case 'home':
        return [Home, '비대면 진료 홈'];
      case 'list':
        return [List, '진료내역'];
      case 'sign_in':
        return [SignIn, '로그인'];
      case 'sign_out':
        return [SignOut, '로그아웃'];
    }
  }, [name]);

  return (
    <div css={styles.container} ref={ref}>
      <Icon
        css={[
          styles.icon,
          isWide && styles.wideIcon,
          !isWide && name === 'home' && styles.focusedIcon,
          focused && styles.focusedIcon
        ]}
      />
      {isWide && <span css={[styles.title, focused && styles.focusedText]}>{text}</span>}
    </div>
  );
};

export default FocusableNavItem;
